import FakeCartItemConf from "./FakeCartItemConf";
export default FakeCartItemConf;
